module.exports = __webpack_public_path__ + "img/pdr-logo.15023792.png";